// extracted by mini-css-extract-plugin
export default {"container":"container_Su2PE","content":"content_PwMc8","text":"text_gjcwk","button":"button_PBuWI"};